import { isTimestampAfterCurrentDate } from "../helpers/datetimeHelper";
export function validRedemptionRules(
    RedemptionRules = [],
    storeZone,
    cartValue = 0,
    userRedemptionPoints,
    redemptionLocalUsedPoints,
    storeMenu,
    orderItems = []
) {
  orderItems = orderItems.filter((item) => !item.reedemptionRule);
  let validRedemptionRules = RedemptionRules.filter((pt) => {
    const validExpiry =
        !pt.ExpiredDate ||
        (pt.ExpiredDate &&
            isTimestampAfterCurrentDate(pt.ExpiredDate.seconds, storeZone));
    const validDollarSpent = pt.DollarSpent <= cartValue;
    const userHasEnoughPoints =
        userRedemptionPoints - redemptionLocalUsedPoints >= pt.Point;
    let validProductRedeemption = true;
    if (pt.ProductVariant) {
      validProductRedeemption = orderItems.some(
          (item) => item.id.toString() === pt.ProductVariant.toString()
      );
    }
    let validCategory = true;
    if (pt.Categories && pt.Categories.length > 0) {
      validCategory = pt.Categories.some((ct) =>
          orderItems.some(
              (item) =>
                  !item.ProductCategoryIDs ||
                  item.ProductCategoryIDs.includes(ct.toString())
          )
      );
    }
    let validTag = true;
    if (pt.Tags && pt.Tags.length > 0) {
      validTag = pt.Tags.some((tg) =>
          orderItems.some(
              (item) =>
                  !item.ProductTagIDs || item.ProductTagIDs.includes(tg.toString())
          )
      );
    }
    return (
        !pt.Disable &&
        validExpiry &&
        validDollarSpent &&
        userHasEnoughPoints &&
        validProductRedeemption &&
        validCategory &&
        validTag
    );
  });
  // descending order
  validRedemptionRules.sort((a, b) => {
    return b.Point - a.Point;
  });
  let selectedRule = validRedemptionRules[0];
  if (selectedRule) {
    selectedRule = { ...selectedRule };
    let product = storeMenu.Categories.flatMap((ct) => ct.SubMenuItems).find(
        (p) => p.ProductID == selectedRule.ProductVariant
    );
    if (selectedRule.ProductVariant && !product) {
      return null;
    }
    selectedRule.AppliedDiscount = calculateRuleDiscount(
        selectedRule,
        cartValue,
        product
    );
  }
  return selectedRule || null;
}
export function calculateRuleDiscount(rule, cartValue, product) {
  let discount = 0;
  let value = 0;
  if (rule && rule.ProductVariant) {
    value = product.Price;
  } else {
    value = cartValue;
  }
  if (rule.DiscountRate) {
    discount = value * (rule.DiscountRate / 100);
  } else if (rule.DiscountAmount) {
    discount = rule.DiscountAmount;
    if (discount > cartValue) {
      discount = cartValue;
    }
  }
  return discount;
}
